"use client";

import { useEffect, useRef, useState } from "react";

interface EmbedFrameProps {
	url: string;
	title: string;
	height: number;
	autoHeight: boolean;
	heightKey: string;
}

export const EmbedFrame: React.FC<EmbedFrameProps> = ({ url, title, height, autoHeight, heightKey }) => {
	const frame = useRef<HTMLIFrameElement>(null);
	const [frameHeight, setFrameHeight] = useState(height);
	const [listening, setListening] = useState(false);

	useEffect(() => {
		if (!autoHeight) return;

		const onMessage = (event: MessageEvent) => {
			if (event.source !== frame.current?.contentWindow || typeof event.data !== "object" || event.data === null) return;

			const reported = (event.data as Record<string, unknown>)[heightKey];
			const value = typeof reported === "string" ? parseInt(reported, 10) : reported;

			if (typeof value !== "number" || !isFinite(value) || value <= 0) return;

			setFrameHeight(Math.ceil(value));
		};

		window.addEventListener("message", onMessage);
		setListening(true);

		return () => window.removeEventListener("message", onMessage);
	}, [autoHeight, heightKey]);

	return (
		<iframe
			ref={frame}
			src={autoHeight && !listening ? undefined : url}
			title={title}
			height={frameHeight}
			className="block w-full border-0"
			loading="lazy"
		/>
	);
};
